<script>
  import {selectedChannelId} from "./channels/channelStore";
  import firebase from 'firebase';
  import MyChannelList from "./channels/MyChannelList.svelte";
  import ChannelPage from "./channels/ChannelPage.svelte";
  import Modal from "./modal/Modal.svelte";
  import {modals} from './modal/modalStore';
  import {confirms} from './popup/popupStore';
  import Confirm from "./popup/Confirm.svelte";

</script>

{#if !!$selectedChannelId}
  <ChannelPage channelId={$selectedChannelId}/>
{:else}
  <MyChannelList style="height: 100%;"/>
{/if}

{#each $modals as modal}
  <Modal visible {...modal.modalProps}>
    <svelte:component this={modal.component} {...modal.contentProps}/>
  </Modal>
{/each}

{#each $confirms as confirm}
  <Confirm
      visible
      {...confirm.props}
  />
{/each}